module.exports = __webpack_public_path__ + "img/login-key.006be4cb.svg";